import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import DriversList from './DriversList';
import AddDriver from './AddDriver';
import EditDriver from './EditDriver';
import SingleDriver from './SingleDriver';


class Driver extends Component {
    render () {
        return (
            <Switch>
                <Route path="/drivers" exact component={ DriversList } />
                <Route path="/drivers/add" exact component={ AddDriver } />
                <Route path="/drivers/:id/edit" component={ EditDriver } />
                <Route path="/drivers/:id" component={ SingleDriver } />
            </Switch>
        )
    }
}

export default Driver;



// WEBPACK FOOTER //
// ./src/components/Driver/index.js